module.exports = __webpack_public_path__ + "static/media/gb-wls.d67608c4.svg";